import Rest from '@services/Rest'

/**
 * @typedef {ClaimService}
 */
export default class ClaimService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/claim'
}
